export const environment = {
  production: false,
  baseUrl: 'https://uat-k-privileges.vthgdigital.com/api',
  hostUrl: 'https://uat-k-privileges.vthgdigital.com',
  apiUrl: 'https://uat-k-privileges.vthgdigital.com/api',
  recaptcha: {
    siteKey: '6Ldl3rApAAAAAPi1XueFRrsYsy6cYkDJem3OsuXX',
  },
  recaptchaV3: {
    siteKey: '6LdASLYqAAAAAIE8v2gFZUBkChWdPVQ-b9B996sF',
  },
};
